import React, { Component, Fragment } from "react";
import { SubMenuLink } from "./SubMenuLink";
import { CreateSlideIcon } from "../../Common/Icons";

export default class SlideListLink extends Component {
  render() {
    return (
      <Fragment>
        <SubMenuLink pathname={"/slides"} title={"slidesModels"}>
          <CreateSlideIcon className={""} />
        </SubMenuLink>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SlideListLink.js